import { IGetConversationQuery, IGetConversationResult } from "./../interfaces/i-message";
import { autoinject } from "aurelia-framework";
import { HospiceClient } from "../common/hospice-client";
import Infrastructure from "../common/infrastructure";

@autoinject()
export class AxxessChatService {
    private _httpClient: HospiceClient;
    private _baseAxxessMessagingUrl: string = `${Infrastructure.messagingServerUrl}/api/v1/conversations`;

    public constructor(httpClient: HospiceClient) {
        this._httpClient = httpClient;
    }

    public async getAxxessChatConversations(query: IGetConversationQuery) {
        return await this._httpClient
            .build(`${this._baseAxxessMessagingUrl}/unread`)
            .useMode("cors")
            .useQueryString(query)
            .fetch<IGetConversationResult>();
    }
}
